<template>
    <div class="virtual-app">
        <div class="client-app-inc" style="height:200px" v-if="isLoading">
          <Loader></Loader>
        </div>
        <div class="container" v-show="!inPlay && !isLoading"> 
            <div class="app-casino-mobile" v-if="isMobile">
                <MobileHeader/>
            </div>
            <Providers v-if="!isMobile"/>
            <Games @loginModal="loginModal = $event"/>
        </div>
        <div class="client-app-inc" v-if="inPlay">
            <GameWindow/>
        </div>
        <Modal class="casino-login-modal" @modalStatus="loginModal = $event" :isVisible="loginModal && !$auth()">
          <template slot="content">
              <UserLogin/>
          </template>
        </Modal>
    </div>
</template>

<script>
  import GameWindow from '../../components/Virtual/GameWindow'
  import Providers from '../../components/Virtual/Providers'
  import Games from '../../components/Virtual/Games'
  import MobileHeader from '../../components/Virtual/MobileHeader'
  import UserLogin from '../../views/Auth/Login'
  export default{
    name : 'Virtual',
    data(){
      return{
        isLoading: true,
        loginModal: false,
      }
    },
    computed:{
      inPlay(){
        return this.$store.getters['virtual/getInPlay'];
      },
    },
    created(){
      this.fetchData();
    },
    methods:{
      fetchData(){
        this.isLoading = true;
        this.$store.dispatch('virtual/initVirtual')
        .then(response =>{
          this.isLoading = false;
          return response
        })
      }
    },
    components:{
      Providers,
      MobileHeader,
      GameWindow,
      Games,
      UserLogin
    }
  }
</script>